import ShowTip from './scripts/ShowTip';
import BackpackGameForm from './scripts/BackpackGameForm';
import WinConfetti from './scripts/WinConfetti';
import Alpine from 'alpinejs';
import axios from 'axios';

ShowTip.init();
BackpackGameForm.init();
WinConfetti.init();

window.Alpine = Alpine;
Alpine.start();
window.axios = axios;
